(function () {
  'use strict';

  angular.module('app').component('creditNoteStatusLabel', creditNoteStatusLabel());

  function creditNoteStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: CreditNoteStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  CreditNoteStatusLabelComponent.$inject = ['$translate'];

  function CreditNoteStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusLabel = 'default';
      let statusTitle = 'DRAFT';

      switch (vm.status) {
        case 'draft':
          statusLabel = 'default';
          statusTitle = 'DRAFT';
          break;
        case 'processed':
          statusLabel = 'success';
          statusTitle = 'PROCESSED';
          break;
      }

      vm.statusLabel = statusLabel;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
